module.exports = __webpack_public_path__ + "media/images/pages/img_culture_facility_02-c147e3483860febb2e9dd462e284f84d.jpg";